module.exports = __webpack_public_path__ + "static/media/percentage-inactive.a291fcaf.svg";